module.exports = __webpack_public_path__ + "assets/img/278.png?c588ea13b898aa69a506359afa93ae0f";